import { PortableText } from "@portabletext/react"
import { SanityBlock } from "sanity-codegen"
import styles from "./SanityRichTextField.module.css"
import { classNames } from "@punks/ui-core"

export interface RichTextFieldProps {
  value: (SanityBlock & { _key: string })[] | undefined
  className?: string
  multiline?: boolean
}

const SanityRichTextField = ({
  value,
  className,
  multiline,
}: RichTextFieldProps) => {
  if (!value) {
    return <></>
  }
  if (typeof value === "string") {
    return <>{value}</>
  }

  // Custom components for PortableText
  const components = {
    marks: {
      link: ({
        value,
        children,
      }: {
        value?: { href?: string }
        children?: React.ReactNode
      }) => {
        return (
          <a href={value?.href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        )
      },
    },
  }

  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles.multiline]: multiline,
        },
        className
      )}
    >
      <PortableText value={value} components={components} />
    </div>
  )
}

export default SanityRichTextField
